// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/PurchasedProducts/Handlers/LoadPurchasedProducts";

export const TpsLoadProducts: typeof LoadProducts = props => {
    const {
        getProductCollectionParameter,
        dispatch,
        parameter: { widgetId: id },
    } = props;
    if (!getProductCollectionParameter) {
        return false;
    }
    // XNG-Change: send force load TPS-861
    dispatch(
        loadProductInfoList({
            getProductCollectionParameter,
            id,
            forceLoad: true,
        }),
    );
};

replaceInChain(chain, LoadProducts, TpsLoadProducts);
